import { IColumn } from '../../components';

export const InitiativeColumns: IColumn[] = [
  {
    id: 'initiativeType',
    name: 'Type',
  },
  {
    id: 'title',
    name: 'Initiative',
    width: '20%',
  },
  {
    id: 'priority',
    name: 'Priority',
    width: '20%',
  },
  {
    id: 'initiativeDueDate',
    name: 'Due Date',
    width: '20%',
  },
  {
    id: 'initiativeNote',
    name: 'Notes',
    width: '20%',
  },
] as const;

export const CompletedInitiativeColumns: IColumn[] = [
  {
    id: 'initiativeType',
    name: 'Type',
  },
  {
    id: 'title',
    name: 'Initiative',
    width: '20%',
  },
  {
    id: 'priority',
    name: 'Priority',
    width: '10%',
  },
  {
    id: 'initiativeDueDate',
    name: 'Due Date',
    width: '20%',
  },
  {
    id: 'initiativeNote',
    name: 'Notes',
    width: '15%',
  },
  {
    id: 'actioned',
    name: 'Actioned',
    width: '5%',
  },
] as const;

export const CalculatedKpiColumns: IColumn[] = [
  {
    id: 'kpi',
    name: '',
    width: '41%',
  },
  {
    id: 'globalBenchmarkKpi',
    name: 'Global Benchmark',
    width: '17%',
  },
  {
    id: 'avedaSalonData',
    name: 'Salon Data',
    width: '17%',
  },
  {
    id: 'status',
    name: 'Status',
    width: '25%',
  },
] as const;

export const RawKpiColumns: IColumn[] = CalculatedKpiColumns.map((col) =>
  col.id === 'status' ? { ...col, id: '', name: '' } : col,
);

export enum ActionPlanGroupsTitle {
  actualGuestCount = 'Actual Guest Count',
  plannedGuestCount = 'Planned Guest Count',
  actualSpCount = 'Actual Service Provider Count',
  plannedSpCount = 'Planned Service Provider Count',
  retailTransactions = 'Actual Retail Transactions',
  serviceTransactions = 'Actual Service Transactions',
  plannedHigherTicketsCount = 'Planned Retail Transactions',
  plannedRetailTicketsCount = 'Planned Service Transactions',
  kpiActual = 'Actual Benchmark Values',
  kpiPlanned = 'Planned Benchmark Values',
}

export enum ActionPlanGroupsTitleDescription {
  actualGuestCount = 'Total # of Guests in the past quarter',
  plannedGuestCount = 'Goal for Total # of Guests in the next quarter',
  actualSpCount = 'Total # of Service Provider in the past quarter',
  plannedSpCount = 'Goal for Total # of Service Provider in the next quarter',
  retailTransactions = 'Total # of Retail Transactions in the past quarter',
  serviceTransactions = 'Total # of Service Transactions in the past quarter',
  plannedHigherTicketsCount = 'Goal for Total # of Retail Transactions in the next quarter',
  plannedRetailTicketsCount = 'Goal for Total # of Service Transactions in the next quarter',
}

export const blocksOrder: { [key: string]: number } = {
  retailTransactions: 0,
  serviceTransactions: 1,
  actualGuestCount: 1,
  actualSpCount: 1,
  plannedGuestCount: 2,
  plannedSpCount: 2,
  plannedHigherTicketsCount: 2,
  plannedRetailTicketsCount: 2.5,
  kpi: 3,
};
